import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function BannedItemDetail() {
  const {id} = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saved, setSaved] = useState(location.state?.saved || false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => { if (saved) { const t = setTimeout(() => setSaved(false), 3000); return () => clearTimeout(t); } }, [saved]);

  useEffect(() => {
    api(`/banned-items/${id}`).then(r => r.ok ? r.json() : null).then(data => { setItem(data); setLoading(false); });
  }, [id]);

  const handleDelete = () => {
    api(`/banned-items/${id}`, {method: 'DELETE'}).then(() => navigate('/banned-list'));
  };

  if (loading) return <Layout><div className="p-6">Loading...</div></Layout>;
  if (!item) return <Layout><div className="p-6">Not found.</div></Layout>;

  return (
    <Layout>
      {saved && <div className="mb-4 px-4 py-3 bg-green-100 text-green-800 rounded-lg">Saved successfully.</div>}
      <Link to="/banned-list" className="text-rose-600 hover:text-rose-800 mb-4 inline-block">&larr; Back</Link>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900">{item.name}</h2>
          <div className="flex gap-3">
            <Link to={`/banned-list/${id}/edit`} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Edit</Link>
            <button onClick={() => setShowDelete(true)} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-500">Reason</label>
            <p className="mt-1 text-gray-900">{item.reason}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500">Added By</label>
            <p className="mt-1 text-gray-900">{item.addedBy}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500">Date Added</label>
            <p className="mt-1 text-gray-900">{new Date(item.createdAt).toLocaleDateString()}</p>
          </div>
        </div>
      </div>

      {showDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-96">
            <h3 className="text-lg font-bold text-gray-900 mb-2">Delete Entry</h3>
            <p className="text-gray-600 mb-6">Are you sure you want to remove this from the banned list?</p>
            <div className="flex justify-end gap-3">
              <button onClick={() => setShowDelete(false)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
              <button onClick={handleDelete} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
